import api from "../../../core/api";
import { CompanyMachinesQuery } from "../../companies/models/models";
import { Machine, PublicMachineProfile } from "../models/models";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.machineryApiBaseUrl };
}

class CustomerPublicMachineryApi {
  getPublickMachines(query: CompanyMachinesQuery): Promise<Record<string, Machine[]>> {
    return api.get<Record<string, Machine[]>>(
      `/v1/public/machines`, { ...getRequestConfig(), params: query, paramsSerializer: { indexes: null } })
      .then(x => x.data);
  }

  getPublicMachine(id: string): Promise<PublicMachineProfile> {
    return api.get<PublicMachineProfile>(
      `/v1/public/machines/${id}/profile`, getRequestConfig())
      .then(x => x.data);
  }

  getMachineCounts(customerIds: string[]): Promise<Record<string, number>> {
    return api.get<Record<string, number>>(
      `/v1/public/machines/counts`,
      { ...getRequestConfig(), params: { customerIds: customerIds.join(',') } }
    ).then(x => x.data);
  }
}

export default new CustomerPublicMachineryApi();